<script>
import cloneDeep from "lodash/cloneDeep";
import required from "vuelidate/lib/validators/required";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Supplier from "@/components/modals/supplier.vue";
import Unit from "@/components/modals/unit.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import Campus from "@/components/modals/campus.vue";

export default {
  page: {
    title: "Properties",
  },
  components: {
    DatePicker,
    MaskedInput,
    FundCluster,
    ItemCategory,
    Supplier,
    Unit,
    Employee,
    Location,
    Campus,
  },
  data() {
    return {
      submitted: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false,
      }),
      tableData: [],
      employeeData: null,
      poData: "",
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      filterOn: [],
      sortBy: "poNumber",
      sortDesc: false,
      fields: [
        {
          key: "poNumber",
          sortable: true,
          label: "Purchase Order",
        },
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true,
        },
      ],
      sideBarGet: true,
      poNumber: "",
      propertyNumber: "",
      employeeId: "",
      employeeIdNumberPrint: "",
      employeeNamePrint: "",
      assignmentNumber: "",
      fundCluster: "",
      fundClusterId: 0,
      fundClusterGet: "",
      getClusterType: "",
      itemCategoryId: 0,
      itemYear: null,
      locationIdSelected: 0,
      campusOptions: this.$store.state.decrypt.campusAccessList(),
      campusId: this.$store.state.data.selectedCampus.id,
      campusSelected: null,
      inventoryTitle: "",
      minCost: "",
      maxCost: "",
      getBy: 1,
      getByValue: 1,
      getByPrint: 1,
      bySearch: true,
      byAll: false,
      perPageCart: 10,
      currentPageCart: 1,
      filterCart: "",
      form: {
        id: null,
        name: "",
        brand: "",
        model: "",
        specification: "",
        color: "",
        dimensionDescription: "",
        materialUsed: "",
        packageDescription: "",
        propertyNumber: "",
        serialNumber: "",
        dateAcquired: "",
        amount: "",
        lifespanInYears: "",
        yearlyDepreciation: "",
        salvageValue: "",
        itemCategoryId: "",
        supplierId: "",
        supplier: "",
        poNumber: "",
        note: "",
        condition: "",
        fundCluster: "",
        fundClusterId: "",
        unit: "",
      },
      transferForm: {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: "",
        remarks: "",
      },
      formAssign: {
        propertyId: "",
        employeeIdNumber: "",
        propertyLocationId: "",
        assignNotes: "",
        assignmentType: "",
        assignmentNumber: "",
      },
      poIndex: -1,
      propertyIndex: -1,
      itemIndex: -1,
      tableBusy: false,
      itemCategory: "",
      itemCategoryGet: "",
      employeeName: "",
      employeeNameGet: "",
      getEmployeeType: "",
      getCategoryType: "",
      getLocationType: "",
      location: "",
      locationGet: "",
      campus: "",
      itemCategoryIdChange: null,
      itemCategoryChange: "",
      dateAcquiredChange: null,
      dateAssignedChange: null,
      unitCostChange: "",
      locationIdChange: null,
      locationChange: "",
      uploadOptions: {
        type: "Property",
        placement: "lefttop",
        folder: "Property",
      },
      accountableEmployee: null,
      multipleUpdateType: "",
    };
  },
  validations: {
    form: {
      name: { required },
      poNumber: { required },
      propertyNumber: { required },
      dateAcquired: { required },
      amount: { required },
      lifespanInYears: { required },
      yearlyDepreciation: { required },
      salvageValue: { required },
      itemCategoryId: { required },
      supplierId: { required },
      supplier: { required },
      condition: { required },
      unit: { required },
    },
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (this.bySearch) {
            if (item.name.toUpperCase().includes(this.filter.toUpperCase())) {
              return item.name
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.currentAssignment &&
              item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          } else {
            if (
              item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.poNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.supplier.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.supplier
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
    compareCost() {
      if (
        parseFloat(this.getExactAmt(this.minCost)) >
          parseFloat(this.getExactAmt(this.maxCost)) ||
        (this.getExactAmt(this.minCost) != "" &&
          this.getExactAmt(this.maxCost) == "")
      )
        return 1;
      else return 0;
    },
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    // change campus
    changeCampus(data) {
      this.campusId = data.id;
      this.getProperties();
    },
    // get
    getProperties() {
      this.getByValue = null;
      setTimeout(() => {
        this.getByValue = this.getBy;
      }, 600);
      this.sideBarGet = true;
      this.tableData = [];
      this.employeeData = null;
      this.poData = "";
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = "";
      if (this.getBy == 1) {
        this.byAll = false;
        setTimeout(() => {
          this.bySearch = true;
        }, 600);
      } else if (this.getBy == 2) {
        this.bySearch = false;
        setTimeout(() => {
          this.byAll = true;
          this.getByPo();
        }, 600);
      }
    },
    getBySearch() {
      if (this.compareCost == 1) {
        return;
      }
      this.tableBusy = true;
      var poNumber = this.poNumber.trim();
      var propertyNumber = this.propertyNumber.trim();
      var employeeIdNumber = this.employeeId.trim();
      var parIcsNumber = this.assignmentNumber.trim();
      var campusId = this.campusId;
      var propertyLocationId = this.locationIdSelected;
      var fundCluster = this.fundCluster.trim();
      var itemCategoryId = this.itemCategoryId;
      var year = 0;
      if (this.itemYear != null && this.itemYear != "") {
        year = this.itemYear.getFullYear();
      }
      var unitCostMin = 0;
      if (
        this.getExactAmt(this.minCost) != null &&
        this.getExactAmt(this.minCost) != ""
      ) {
        unitCostMin = this.getExactAmt(this.minCost);
      }
      var unitCostMax = 0;
      if (
        this.getExactAmt(this.maxCost) != null &&
        this.getExactAmt(this.maxCost) != ""
      ) {
        unitCostMax = this.getExactAmt(this.maxCost);
      }
      this.$store
        .dispatch("property/GetPropertybySearch", {
          poNumber,
          propertyNumber,
          employeeIdNumber,
          parIcsNumber,
          campusId,
          propertyLocationId,
          fundCluster,
          itemCategoryId,
          year,
          unitCostMin,
          unitCostMax,
        })
        .then((res) => {
          res.data.forEach((item) => {
            item.visible = false;
            item.itemVisible = false;
            item.assignmentHistory = [];
            item.assignVisible = false;
            item.assignLoading = false;
            item.inventory = [];
            item.inventoryVisible = false;
            item.inventoryLoading = false;
            item.inspectionVisible = false;
            item.attachmentVisible = false;
            item.attachmentLoading = false;
            item.addDocu = false;
            item.fileSearch = "";
            item.propertyInspections.forEach((inspect) => {
              inspect.inspectionFiles = [];
              inspect.attachmentLoading = false;
            });
          });
          this.tableData = res.data;
          window.scrollTo(0, 0);
          this.employeeData = null;
          if (employeeIdNumber != "") this.getEmployeeInfo();
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    getByPo() {
      this.tableBusy = true;
      this.$store
        .dispatch("property/GetPropertyPosted", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.details = [];
            item.showDetails = false;
            item.rotateChevy = false;
            item.currentPage = 1;
            item.perPage = 5;
            item.filter = "";
            item.tableBusy = false;
          });
          this.tableData = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    getProperty(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
      row.item.details = [];
      if (row.item.showDetails) {
        row.item.tableBusy = true;
        setTimeout(() => {
          var poNumber = row.item.poNumber;
          var status = "POSTED";
          var campusId = this.campusId;
          this.$store
            .dispatch("property/GetPropertybyPO", {
              poNumber,
              status,
              campusId,
            })
            .then((res) => {
              res.data.forEach((item) => {
                item.visible = false;
                item.itemVisible = false;
                item.assignmentHistory = [];
                item.assignVisible = false;
                item.assignLoading = false;
                item.inventory = [];
                item.inventoryVisible = false;
                item.inventoryLoading = false;
                item.inspectionVisible = false;
                item.attachmentVisible = false;
                item.attachmentLoading = false;
                item.addDocu = false;
                item.fileSearch = "";
                item.propertyInspections.forEach((inspect) => {
                  inspect.inspectionFiles = [];
                  inspect.attachmentLoading = false;
                });
              });
              row.item.details = res.data;
              row.item.tableBusy = false;
            })
            .catch(() => {
              row.item.tableBusy = false;
              this.showToast(
                "Something went wrong - Getting property list!",
                "error"
              );
            });
        }, 1000);
      }
    },
    getEmployeeInfo() {
      this.$store
        .dispatch("externalemployee/GetByEmployeeId", this.employeeId.trim())
        .then((res) => {
          this.employeeData = res.data;
        });
    },
    showEmployee(props) {
      if (props) {
        this.accountableEmployee = null;
        this.accountableEmployee = cloneDeep(props);
        this.employeeIdNumberPrint = this.accountableEmployee.idNo;
        this.modalTitle = "Accountable Officer Detail";
        this.$bvModal.show("modal-accountableEmployee");
      }
    },
    onReset() {
      this.form = {
        id: null,
        name: "",
        specification: "",
        color: "",
        dimensionDescription: "",
        materialUsed: "",
        packageDescription: "",
        propertyNumber: "",
        serialNumber: "",
        dateAcquired: "",
        amount: "",
        lifespanInYears: "",
        yearlyDepreciation: "",
        salvageValue: "",
        itemCategoryId: "",
        supplierId: "",
        supplier: "",
        poNumber: "",
        note: "",
        condition: "New",
        fundCluster: "",
        fundClusterId: "",
        unit: "",
      };
      this.formCancel = {
        id: null,
        returnNotes: "",
        dateReturned: "",
      };
      this.transferForm = {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: "",
        remarks: "",
      };
      this.formAssign = {
        employeeIdNumber: "",
        propertyLocationId: "",
        assignNotes: "",
        assignmentType: "",
        assignmentNumber: "",
        dateAssigned: "",
      };
      this.submitted = false;
      this.employeeName = "";
      this.fundCluster = "";
      this.location = "";
      this.poIndex = -1;
      this.propertyIndex = -1;
      this.itemIndex = -1;
    },
    getFundCluster(type) {
      this.$refs.fundcluster.getData();
      this.$bvModal.show("fund-cluster-modal");
      this.getClusterType = type;
    },
    dropFundCluster(data) {
      if (this.getClusterType == "form") {
        this.form.fundClusterId = data.id;
        this.fundCluster = data.cluster;
      } else if (this.getClusterType == "get") {
        this.fundClusterId = data.id;
        this.fundClusterGet = data.cluster;
      }
    },
    removeFundCluster(type) {
      if (type == "form") {
        this.form.fundClusterId = "";
        this.fundCluster = "";
      } else if (type == "get") {
        this.fundClusterId = 0;
        this.fundClusterGet = "";
      }
    },
    getItemCategory(type) {
      this.$refs.itemcategory.filterPropertyCategory();
      this.$bvModal.show("item-category-modal");
      this.getCategoryType = type;
    },
    dropItemCat(data) {
      if (this.getCategoryType == "form") {
        this.form.itemCategoryId = data.id;
        this.itemCategory = data.name;
      } else if (this.getCategoryType == "change") {
        this.itemCategoryIdChange = data.id;
        this.itemCategoryChange = data.name;
      } else {
        this.itemCategoryId = data.id;
        this.itemCategoryGet = data.name;
      }
    },
    removeItemCat(type) {
      if (type == "form") {
        this.form.itemCategoryId = 0;
        this.itemCategory = "";
      } else if (type == "change") {
        this.itemCategoryIdChange = 0;
        this.itemCategoryChange = "";
      } else {
        this.itemCategoryId = 0;
        this.itemCategoryGet = "";
      }

      // this.itemCategoryId = 0;
      // this.itemCategory = "";
    },
    getSupplier() {
      this.$bvModal.show("supplier-modal");
    },
    dropSupplier(data) {
      this.form.supplierId = data.id;
      this.form.supplier = data.name;
    },

    dropUnit(data) {
      this.form.unit = data.unitName;
    },
    getEmployee(type) {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      var firstname = data.firstName;
      var lastname = data.lastName;
      if (this.getEmployeeType == "assign") {
        this.formAssign.employeeIdNumber = data.idNo;
        this.employeeName = firstname.concat(" ", lastname);
      } else if (this.getEmployeeType == "get") {
        this.employeeId = data.idNo;
        this.employeeNameGet = firstname.concat(" ", lastname);
      } else if (this.getEmployeeType == "print") {
        this.employeeIdNumberPrint = data.idNo;
        this.employeeNamePrint = firstname.concat(" ", lastname);
      } else if (this.getEmployeeType == "transfer") {
        this.transferForm.transferToEmployeeId = data.idNo;
        this.employeeName = firstname.concat(" ", lastname);
      }
    },
    removeEmployee(type) {
      if (type == "assign") {
        this.formAssign.employeeIdNumber = "";
        this.employeeName = "";
      } else if (type == "get") {
        this.employeeId = "";
        this.employeeNameGet = "";
      } else if (type == "print") {
        this.employeeIdNumberPrint = "";
        this.employeeNamePrint = "";
      }

      // this.employeeId = "";
      // this.employeeName = "";
    },
    getLocation(type) {
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
      this.getLocationType = type;
    },
    dropLocation(data) {
      if (this.getLocationType == "get") {
        this.locationIdSelected = data.location.id;
        this.locationGet = data.location.location;
      }
      if (this.getLocationType == "form") {
        this.formAssign.propertyLocationId = data.location.id;
        this.location = data.location.location;
      }
      if (this.getLocationType == "change") {
        this.locationIdChange = data.location.id;
        this.locationChange = data.location.location;
      }
    },
    removeLocation(type) {
      if (type == "get") {
        this.locationIdSelected = 0;
        this.locationGet = "";
      }
      if (type == "form") {
        this.formAssign.propertyLocationId = 0;
        this.location = "";
      }
    },
    getCampus() {
      this.$refs.campus.getData();
      this.$bvModal.show("campus-modal");
    },
    dropCampus(data) {
      this.campusSelected = data;
      this.campus = data.campusName;
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    },
  },
};
</script>

<template>
  <div>
    <!-- Main -->
    <div class="row">
      <!-- Side Bar -->
      <div class="col-md-3">
        <!-- Get By -->
        <div
          class="card border-4 border-top border-start-0 border-end-0 border-primary"
        >
          <div class="card-body pt-3 pb-3 ps-4 pe-4">
            <b-collapse :visible="getByValue == 1 && sideBarGet">
              <div v-if="getByValue == 1 && sideBarGet">
                <!-- P.O. # -->
                <div class="mt-2 mb-1">P.O. Number</div>
                <div id="poNumber" class="position-relative">
                  <input
                    autocomplete="off"
                    type="text"
                    class="form-control rounded border-light"
                    placeholder="Input PO Number..."
                    v-model="poNumber"
                  />
                </div>
                <!-- Property # -->
                <div class="mt-2 mb-1">Property Number</div>
                <div id="propertyNumber" class="position-relative">
                  <input
                    autocomplete="off"
                    type="text"
                    class="form-control rounded border-light"
                    placeholder="Input Property Number..."
                    v-model="propertyNumber"
                  />
                </div>
                <!-- Employee -->
                <div class="mt-2 mb-1">Employee ID</div>
                <b-input-group>
                  <template #append>
                    <b-button
                      v-if="employeeId == ''"
                      @click="getEmployee('get')"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                    <b-button
                      v-else
                      @click="removeEmployee('get')"
                      variant="outline-danger"
                      title="Remove Employee"
                      ><i class="mdi mdi-close-thick"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    type="text"
                    placeholder="Input Employee ID..."
                    class="form-control rounded border-light"
                    v-model="employeeId"
                  />
                </b-input-group>
                <!-- PAR/ICS -->
                <div class="mt-2 mb-1">PAR/ICS Number</div>
                <div id="assignmentNumber" class="position-relative">
                  <input
                    autocomplete="off"
                    type="text"
                    class="form-control rounded border-light"
                    placeholder="Input PAR/ICS Number..."
                    v-model="assignmentNumber"
                  />
                </div>
                <!-- Location -->
                <div class="mt-2 mb-1">Location</div>
                <b-input-group>
                  <template #append>
                    <b-button
                      v-if="locationIdSelected == 0"
                      @click="getLocation('get')"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                    <b-button
                      v-else
                      @click="removeLocation('get')"
                      variant="outline-danger"
                      ><i class="mdi mdi-close-thick"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    type="text"
                    disabled
                    placeholder="Search Location..."
                    class="form-control rounded border-light"
                    v-model="locationGet"
                  />
                </b-input-group>
                <!-- Fund Cluster -->
                <div class="mt-2 mb-1">Fund Cluster</div>
                <b-input-group>
                  <template #append>
                    <b-button
                      v-if="fundClusterId == 0"
                      @click="getFundCluster('get')"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                    <b-button
                      v-else
                      @click="removeFundCluster('get')"
                      variant="outline-danger"
                      title="Remove Fund Cluster"
                      ><i class="mdi mdi-close-thick"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    type="text"
                    disabled
                    placeholder="Search Fund Cluster..."
                    class="form-control rounded border-light"
                    v-model="fundClusterGet"
                  />
                </b-input-group>
                <!-- Category -->
                <div class="mt-2 mb-1">Item Category</div>
                <b-input-group>
                  <template #append>
                    <b-button
                      v-if="itemCategoryId == 0"
                      @click="getItemCategory('get')"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                    <b-button
                      v-else
                      @click="removeItemCat('get')"
                      variant="outline-danger"
                      title="Remove Item Category"
                      ><i class="mdi mdi-close-thick"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    type="text"
                    disabled
                    placeholder="Search Item Category..."
                    class="form-control rounded border-light"
                    v-model="itemCategoryGet"
                  />
                </b-input-group>
                <!-- Year -->
                <div class="mt-2 mb-1">Year</div>
                <date-picker
                  id="year"
                  v-model="itemYear"
                  :first-day-of-week="1"
                  type="year"
                  lang="en"
                  class="rounded border-light"
                  placeholder="Select Year..."
                ></date-picker>
                <!-- Cost -->
                <div class="mt-2 mb-1">Cost</div>
                <div class="d-flex justify-content-between">
                  <div class="me-3">
                    <masked-input
                      id="minCost"
                      type="text"
                      v-model="minCost"
                      placeholder="Min Cost..."
                      class="form-control rounded border-light"
                      :class="{
                        'is-invalid': submitted && $v.form.amount.$error,
                      }"
                      autocomplete="off"
                      :mask="currencyMask"
                    ></masked-input>
                    <div
                      v-if="submitted && $v.form.amount.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.amount.required"
                        >This value is required.</span
                      >
                    </div>
                  </div>
                  <div>
                    <masked-input
                      id="maxCost"
                      type="text"
                      v-model="maxCost"
                      placeholder="Max Cost..."
                      class="form-control rounded border-light"
                      :class="{
                        'is-invalid': compareCost == 1,
                      }"
                      autocomplete="off"
                      :mask="currencyMask"
                    ></masked-input>
                    <div v-if="compareCost == 1" class="invalid-feedback">
                      <span>Max Cost should be greater than Min Cost.</span>
                    </div>
                  </div>
                </div>
                <!-- Get -->
                <hr class="my-3" />
                <button
                  type="button"
                  @click="getBySearch"
                  class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mt-3 mb-1"
                >
                  <i class="bx bx-download fs-6 me-2"></i>Get Properties
                </button>
              </div>
            </b-collapse>
          </div>
        </div>
        <!-- Print -->
      </div>
      <!-- Properties -->
      <div class="col-md-9">
        <!-- Searched Property -->
        <transition name="slide">
          <div
            v-if="bySearch"
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="row mb-1">
                <div class="col-md-6">
                  <div>
                    <h5 class="m-0 mb-1">List of Properties</h5>
                    <transition name="fade">
                      <h6
                        v-if="employeeData && employeeData.firstName"
                        class="m-0 d-flex align-items-center"
                      >
                        {{
                          employeeData.firstName.charAt(0).toUpperCase() +
                          employeeData.firstName.slice(1)
                        }}
                        {{
                          employeeData.middleName
                            ? `${employeeData.middleName
                                .charAt(0)
                                .toUpperCase()}.`
                            : ""
                        }}
                        {{
                          employeeData.lastName.charAt(0).toUpperCase() +
                          employeeData.lastName.slice(1)
                        }}
                        <i
                          @click="showEmployee(employeeData)"
                          v-b-tooltip.top.hover="'Print Records'"
                          class="bx bx-printer text-purple font-size-18 cursor-pointer ms-1"
                        ></i>
                      </h6>
                    </transition>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end align-items-center">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          @input="currentPage = 1"
                          placeholder="Search Property..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptionsLg"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-table-responsive mb-0 mt-2">
                <b-table
                  class="propertyTable datatables target-table"
                  thead-class="d-none"
                  :items="filtered"
                  :fields="propertyFields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  sort-by="id"
                  :sort-desc="false"
                  :busy="tableBusy"
                  bordered
                  selectable
                  hover
                  select-mode="single"
                  @row-clicked="$emit('fetchprop', $event)"
                  show-empty
                >
                  <template #empty>
                    <b-card-header>
                      <div class="text-center">
                        <div v-if="filter != ''">
                          <i class="fas fa-exclamation-triangle me-2"></i>There
                          are no properties matching your request
                        </div>
                        <div v-else>
                          <i class="fas fa-exclamation-triangle me-2"></i>No
                          properties available
                        </div>
                      </div>
                    </b-card-header>
                  </template>
                  <template #table-busy>
                    <b-card-header>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="preloader-component me-2">
                          <div class="status">
                            <div class="spinner-chase w-20px h-20px">
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                            </div>
                          </div>
                        </div>
                        <strong>Loading...</strong>
                      </div>
                    </b-card-header>
                  </template>
                  <template #cell(name)="propertyRow">
                    <b-card-header
                      header-tag="header"
                      role="tab"
                      class="border"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center pe-5">
                          <div
                            :style="
                              propertyNumberWidth(
                                (currentPage - 1) * perPage +
                                  (propertyRow.index + 1)
                              )
                            "
                            class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                          >
                            <h3 class="mb-0 position-relative">
                              {{
                                (currentPage - 1) * perPage +
                                (propertyRow.index + 1)
                              }}
                            </h3>
                          </div>
                          <div class="text-muted">
                            <h5 class="mb-0">
                              {{ propertyRow.item.name }}
                            </h5>
                            <div style="min-width: max-content">
                              <small class="d-flex align-items-center"
                                >{{
                                  propertyRow.item.propertyNumber &&
                                  propertyRow.item.propertyNumber !=
                                    "Not Indicated"
                                    ? `Property# ${propertyRow.item.propertyNumber}`
                                    : "Not Indicated"
                                }}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center ms-5"
                        >
                          <div
                            style="width: 200px"
                            class="d-flex align-items-center"
                          >
                            <div class="text-muted">
                              <div>
                                <small class="d-flex align-items-center">
                                  PO Number:
                                </small>
                              </div>
                              <h6 class="mb-0 text-warning">
                                {{ propertyRow.item.poNumber }}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center ms-3"
                        >
                          <div
                            style="width: 200px"
                            class="d-flex align-items-center"
                          >
                            <div class="text-muted">
                              <div>
                                <small class="d-flex align-items-center">
                                  Current Value:
                                </small>
                              </div>
                              <h6 class="mb-0 text-warning">
                                {{
                                  formatCurrency(propertyRow.item.currentValue)
                                }}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-header>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <fund-cluster
      ref="fundcluster"
      @dropData="dropFundCluster($event)"
    ></fund-cluster>
    <item-category
      ref="itemcategory"
      @dropData="dropItemCat($event)"
    ></item-category>
    <supplier @dropData="dropSupplier($event)"></supplier>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
  </div>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.tooltip {
  opacity: 1 !important;
}

.slide-enter-active {
  animation: slide-in 0.5s;
}

.slide-leave-active {
  animation: slide-in 0.5s reverse;
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slide-in {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0 !important;
}
</style>
